import styled from 'styled-components'

const AngleSpanUi = styled.div`
  padding: 5px;
  cursor: pointer;
  user-select: none;
`
export default AngleSpanUi
